import ShortLoadingAnimation from './modules/short-loading.js';
/**
 * 指定時間後にpromiseを返す
 *
 * @param {int} ms
 */
function sleep(ms) {
  return new Promise(function(resolve) {
    setTimeout(function() {
      resolve();
    }, ms);
  });
}
/**
 * 要素を生成する。
 * @param  {String} dom DOMの種類
 * @param  {String} cl [cl=""]  クラス属性
 * @param  {String} inner [inner=""]  innerHTML
 * @param  {Array}  obj [obj=[]] [{key:属性,val:value},{...}]の形式で渡す
 * @param  {HTMLObject} append appendChildする場合は親の要素を指定
 * @return {Object} HTML Elementを返す
 */
function createDom(dom, cl="",inner="", obj=[],append="")
{
  const returnEl = document.createElement(dom);
  if(cl!=="")
  {
    returnEl.classList.add(cl);
  }
  if(obj.length)
  {
    obj.forEach((attr, i) => {
      returnEl.setAttribute(attr.key,attr.val);
    });
  }
  if(inner!=="")
  {
    returnEl.innerHTML = inner;
  }
  if(append !== "")
  {
    append.appendChild(returnEl);
  }
  return returnEl;
}
const apiUrl = httpUrl + 'blog.zaty.jp/wp-json/works/lists';
/**
 * @param {Object} getObject ObjectをGETリクエストの形に変換する
 * @return {String} ?aa=bb&cc=ddの形で出力
 */
const transformGetRequestArray = getArray => {
  let returnArray = [];
  for ( let key in getArray) {
    if (getArray.hasOwnProperty(key)) {
      returnArray.push( key + '=' + getArray[key] );
    }
  }
  let returnString = returnArray.join('&');
  returnString = '?' + returnString;
  return returnString;
}
/**
 * オブジェクトの情報から実績一覧のカードのHTMLDOMを生成する。
 * @param {Object} item
 * @return {HTMLObject}
 */
const createWorksCard = item => {
  const returnCard = document.createElement('div');
  returnCard.classList.add('works-lists-card');

  const cardLink = document.createElement('a');
  cardLink.href = homeUrl + '/works/' + item.id;
  returnCard.appendChild(cardLink);

  const cardThumbnailArea = document.createElement('div');
  cardThumbnailArea.classList.add('works-lists-card__thumbnail');
  cardLink.appendChild(cardThumbnailArea);

  const cardThumbnail = document.createElement('img');
  cardThumbnail.src = item.thumbnail_url ? item.thumbnail_url : templatePath + '/img/noImage.jpg';
  cardThumbnail.alt = item.title + 'のサムネイル';
  cardThumbnailArea.appendChild(cardThumbnail);

  const cardSlug = document.createElement('div');
  cardSlug.classList.add('works-lists-card__plan');
  cardSlug.innerText = item.category_name;
  cardThumbnailArea.appendChild(cardSlug);

  if(item.client)
  {
    const cardCrient = document.createElement('div');
    cardCrient.classList.add('works-lists-card__client');
    cardCrient.innerText = item.client;
    cardLink.appendChild(cardCrient);
  }
  const cardTitle = document.createElement('div');
  cardTitle.classList.add('works-lists-card__title');
  cardTitle.innerText = item.title;
  cardLink.appendChild(cardTitle);

  const svgContent = document.createElement('div');
  svgContent.classList.add('works-lists-card__image');
  svgContent.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="41.811" height="9.28" viewBox="0 0 41.811 9.28"><path d="M5.5,4h40l-8-8" transform="translate(-5.5 4.533)" fill="none" stroke="#fff" stroke-width="1.5"/></svg>`;
  cardLink.appendChild(svgContent);

  return returnCard;
}
/**
 * ページ情報からページナビのHTMLDOMを生成する。
 * @param {Object} item
 * @return {HTMLObject}
 */
const createPageNavigation = (item,worksContent) => {
  const max = item.max_page;
  const current = item.current_page;

  const returnPage = document.createElement('div');
  returnPage.classList.add('works-pagination');

  let pageCheckArray = [];
  if (max === 1) {
    return null
  } else if (max <= 5)
  {
    for (let i = 1; i <= max; i++) {
      pageCheckArray.push(i);
    }
  }else if(current-2 <= 1)
  {
    pageCheckArray.push(1,2,3,4,'>',max);
  }else if(current+2 >= max)
  {
    pageCheckArray.push(1,'>');
    pageCheckArray.push(max-3,max-2,max-1,max)
  }else
  {
    pageCheckArray.push(1,'>');
    pageCheckArray.push(current-1,current,current+1);
    pageCheckArray.push('>',max);
  }
  pageCheckArray.forEach(page => {
    if(page === '>')
    {
      const dotNode = document.createElement('div');
      dotNode.classList.add('works-pagination__dot');
      dotNode.innerText = '…';
      returnPage.appendChild(dotNode);
    }else
    {
      const pageNode = document.createElement('div');
      pageNode.classList.add('works-pagination__item');
      pageNode.dataset.page = page;
      pageNode.innerText = page;
      if(page === current)
      {
        pageNode.classList.add('works-pagination__item--current');
      }else
      {
        pageNode.addEventListener('click', e =>{
          const target = e.currentTarget;
          const pageData = target.dataset.page;
          const getParamObject = {
            category: 'all',
            paged: pageData,
          }
          const url = apiUrl + transformGetRequestArray(getParamObject);
          appendContent(url, worksContent);
        });
      }
      returnPage.appendChild(pageNode);
    }
  });
  return returnPage;
}
/**
 * URLを指定して要素を挿入する
 * @param  {String} url
 * @param  {Object} worksContent
 */
const appendContent = (url,worksContent) =>{
  loadingFlag = true;
  const firstLoading = new ShortLoadingAnimation;
  firstLoading.start();
  const worksCardDomArray = [];
  let worksListTimeout = '';
  worksContent.innerHTML = '';
  const paginationContent = S('.jsPageNav');
  paginationContent.innerHTML = '';
  window.scrollTo( {
    top: 0,
    behavior: "smooth",
  } );
  fetch(url)
  .then( res => res.json() )
  .then( data => {
    if(data[0] === 'not found') return;
    const pageObj = data.shift();
    data.forEach((item, i) => {
      worksCardDomArray.push(createWorksCard(item));
    });
    return pageObj;
  })
  .then( pageObj => {
    if(!pageObj)
    {
      firstLoading.end();
      return;
    }
    const cardLength = worksCardDomArray.length;
    let cardI = 0;
    const appendCard = () => {
      cardI++;

      if(cardI <= cardLength)
      {
        worksContent.appendChild(worksCardDomArray[cardI-1]);
        sleep(80)
        .then(()=>{
          worksCardDomArray[cardI-1].classList.add('works-lists-card--visible');
        });
        worksListTimeout = setTimeout(()=>{
          appendCard();
        },80);
      }else
      {
        clearTimeout(worksListTimeout);
        const paginationElement = createPageNavigation(pageObj, worksContent)
        if (paginationElement === null) {
          paginationContent.style.display = 'none'
        } else {
          paginationContent.style.display = 'block'
          paginationContent.appendChild(paginationElement)
        }
      }
    }
    appendCard();
    return sleep(1000);
  })
  .then(()=>{
    firstLoading.end();
    loadingFlag = false;
  });
}
let loadingFlag = false;
window.addEventListener('load',()=>{
  const worksContent = S('.jsWorksContent');
  if( typeof worksContent !== 'undefined' )
  {
    const getParamObject = {
      category: 'all',
      paged: '1',
    }
    const url = apiUrl + transformGetRequestArray(getParamObject);

    appendContent(url, worksContent);

    const navigationLists = S('.jsNavigationLists');
    const navigationButtons = navigationLists.querySelectorAll('.works-archives__button-item');
    navigationButtons.forEach((button, i) => {
      button.addEventListener('click', e => {
        const target = e.target;
        if(target.dataset.selected === "true" || loadingFlag) return;
        loadingFlag = true;

        const selectedItem = navigationLists.querySelector('[data-selected="true"]');
        selectedItem.dataset.selected = "false";
        selectedItem.classList.remove('works-archives__button-item--select');
        target.dataset.selected = "true";
        target.classList.add('works-archives__button-item--select');

        const categoryParamObject = {
          category: target.dataset.category,
        }
        const categoryUrl = apiUrl + transformGetRequestArray(categoryParamObject);
        appendContent(categoryUrl, worksContent);
      });
    });

  }
});

/**
 * 実績個別ページ
 */
const singleURL = location.pathname.split('/');
const singleId = singleURL[singleURL.length-1];
const singleAPIURL = httpUrl + 'blog.zaty.jp/wp-json/works/' + singleId;

window.addEventListener('load', ()=>{
  if( typeof S('.works-single') !== 'undefined' )
  {
    fetch(singleAPIURL)
      .then( res => res.json() )
      .then( data => {
        document.title = data.title + ' - ZATYのWEB制作';
        S('.jsBredCrumbName').innerHTML = data.title;
        return data;
      })
      .then( data => {
        const worksPCImage = data.pc_image ? data.pc_image : templatePath + '/img/noImage.jpg';
        const worksSPImage = data.sp_image ? data.sp_image : templatePath + '/img/noImage.jpg';
        const pcImageElement = createDom('img','','',[
          {key: 'src',val: worksPCImage},
          {key: 'alt',val: data.title + 'のPCサイトのスクリーンショット'}
        ],S('.jsSinglePC'));
        const spImageElement = createDom('img','','',[
          {key: 'src',val: worksSPImage},
          {key: 'alt',val: data.title + 'のSPサイトのスクリーンショット'}
        ],S('.jsSingleSP'));

        const worksData = S('.jsSingleData');

        const favDiv = createDom('div','works-single__favicon',"",[],worksData);

        const faviconImageSrc = data.favicon === "" ? templatePath + '/img/works-noimage.png' : data.favicon;
        const favItem = createDom('img','','',[
          {key: 'src',val: faviconImageSrc},
          {key: 'alt',val: data.title + 'のfavicon'}
        ],favDiv);

        const titleP = createDom('p','works-single__title',data.title,[],worksData);
        const clientP = createDom('p','works-single__client',data.works_client,[],worksData);
        const siteUrl = createDom('p','works-single__link',"",[],worksData);

        const launchSVG = '<svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 0 24 24" width="14px" fill="#317DBE"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"/></svg>';

        const siteAnchor = createDom('a','works-single__site',"このサイトにアクセスする"+launchSVG,[
          {key: "href", val: data.works_link},
        ],siteUrl);

        const worksPlan = !data.plan ? "オリジナルプラン" : data.plan;
        const planDiv = createDom('div','works-single__plan',worksPlan,[],worksData);
        const catDiv = createDom('div','works-single__category',data.category,[],worksData);
        const textDiv = createDom('div','works-single__text',data.content,[],S('.jsSingleDisplay'));
      });
  }
});
